import PayoutPage from "./payout-page";

const PayoutRoutes = [{ path: "payout", element: <PayoutPage /> }];

export default PayoutRoutes;